import { apiRequest } from '@/api/http'
import type {
  ApiStatusResponse,
  ConsultantResponse,
  RegistrationInit,
} from '@/api/types'

export function fetchRegistrationInit() {
  return apiRequest<RegistrationInit>('/restApi/registration/init')
}

export function login(loginId: string, password: string) {
  return apiRequest<ApiStatusResponse>('/restApi/auth/', {
    method: 'POST',
    formUrlEncoded: true,
    body: {
      LOGIN: loginId,
      PASSWORD: password,
    },
  })
}

export function fetchConsultant(params: {
  refCode?: string
  memberId?: string
  phone?: string
  city?: string
  langs?: string
  coords?: string
  country?: string
  state?: string
  latitude?: string
  longitude?: string
}) {
  return apiRequest<ConsultantResponse>('/restApi/registration/consultant/', {
    params,
  })
}

export function validateEmail(email: string, country: string, memberId?: string) {
  return apiRequest<ApiStatusResponse>('/restApi/validEmail/', {
    method: 'POST',
    formUrlEncoded: true,
    body: {
      action: 'CheckEmail',
      email,
      country,
      ...(memberId ? { memberId } : {}),
    },
  })
}

export function createAccount(payload: Record<string, string | number>) {
  return apiRequest<ApiStatusResponse>('/restApi/registration/new/', {
    method: 'POST',
    formUrlEncoded: true,
    body: payload,
  })
}

export function renewal(memberId: string, email: string) {
  return apiRequest<ApiStatusResponse>('/restApi/registration/renewal/', {
    method: 'POST',
    formUrlEncoded: true,
    body: { memberId, email },
  })
}

export function changePassword(payload: {
  memberId: string
  code: string
  c_password: string
  c_passwordConfirmed: string
}) {
  return apiRequest<ApiStatusResponse>('/restApi/registration/changepwd/', {
    method: 'POST',
    formUrlEncoded: true,
    body: payload,
  })
}

export function activateAccount(payload: {
  'club-number': string
  birthday: string
  email: string
  phone: string
  phoneCode: string
  password: string
  passwordConfirmed: string
}) {
  return apiRequest<ApiStatusResponse>('/restApi/registration/account/', {
    method: 'POST',
    formUrlEncoded: true,
    body: payload,
  })
}
